import { styled, Box, Text } from '@ltvco/refresh-lib/theme';

export const SearchTypeItem = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  padding: theme.spacing(1),
}));

export const AcceptBand = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  background: '#FFF9F2',
  borderRadius: 12,
  padding: theme.spacing(2.25, 2),
  border: '3px solid #FF4D2D',
  gap: theme.spacing(2),
}));

export const AcceptTitle = styled(Text)(({ theme }) => ({
  fontWeight: 900,
  letterSpacing: 0.8,
  textTransform: 'uppercase',
  color: '#FF4D2D',
  fontSize: theme.typography.pxToRem(18),
}));

export const AcceptLogos = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'wrap',
  justifyContent: 'center',
  gap: theme.spacing(2.5),
}));

export const GooglePayButtonContainer = styled(Box)(() => ({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: 50,
}));

export const DisabledNotice = styled(Box)(() => ({
  width: '100%',
  height: '50px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: '#f5f5f5',
  border: '1px solid #ddd',
  borderRadius: '32px',
  color: '#999',
  opacity: 0.5,
  pointerEvents: 'none',
  textAlign: 'center',
  padding: 10,
}));
